<div class="onboard-page new-input-fields" *ngIf="!showPlanSection">

  <!-- Stepper (static — plan not known before login) -->
  <div class="d-flex justify-content-between mt-3" style="margin-bottom: 38px">
    <div style="width:5%"></div>
    <div class="d-flex justify-content-between onboard-stepper" style="width:90%">
      <div class="onboard-step is-active">
        <div class="step-label">Account Setup</div>
      </div>
      <div class="onboard-step-connector is-active-bar"></div>
      <div class="onboard-step">
        <div class="step-label">Book your Meeting</div>
      </div>
      <div class="onboard-step-connector"></div>
      <div class="onboard-step">
        <div class="step-label">Invite Additional User</div>
      </div>
    </div>
    <div style="width:5%"></div>
  </div>

  <!-- Hero banner -->
  <div class="onboard-hero">
    <div class="onboard-hero-content">
      <div class="onboard-hero-title">Welcome to TaxPlanIQ</div>
      <div class="onboard-hero-subtitle">
        Let's get your account set up. Fill in your details below to start your journey.
      </div>
    </div>
    <div class="onboard-hero-illustration">
      <app-signup-banner></app-signup-banner>
    </div>
  </div>

  <!-- Step card -->
  <div class="step-card new-input-fields">
    <div class="step-card-header" style="border-bottom:none;">
      <label style="font-weight:700;font-family:'Poppins',sans-serif;color:#333333;">Account Setup</label>
      <div style="font-size:12px;color:#667085;">Create your TaxPlanIQ account to get started</div>
    </div>
    <div class="step-card-body">

      <!-- Name row -->
      <div class="d-flex gap-2">
        <label class="w-50">
          First Name *
          <input type="text" [(ngModel)]="signupData.firstName" placeholder="First Name"/>
          <div class="error" *ngIf="signupData.firstName && hasDangerousContent(signupData.firstName)">First name contains invalid characters</div>
        </label>
        <label class="w-50">
          Last Name *
          <input type="text" [(ngModel)]="signupData.lastName" placeholder="Last Name"/>
          <div class="error" *ngIf="signupData.lastName && hasDangerousContent(signupData.lastName)">Last name contains invalid characters</div>
        </label>
      </div>

      <label>
        Company Name *
        <input type="text" [(ngModel)]="signupData.companyName" placeholder="Company Name"/>
        <div class="error" *ngIf="signupData.companyName && hasDangerousContent(signupData.companyName)">Company name contains invalid characters</div>
      </label>

      <label>
        Company Website *
        <div class="input-group">
          <span class="input-group-label" style="background:#F9FAFB;border:1px solid #D0D5DD;border-right:none;padding:0 8px;">
            <i class="material-icons" style="font-size:18px;vertical-align:middle;color:#667085">link</i>
          </span>
          <input class="input-group-field except-input" type="text" [(ngModel)]="signupData.websiteUrl" placeholder="www.companywebsite.com" style="border:1px solid #D0D5DD;border-radius:0 3px 3px 0;color:#444;font-size:0.95em;box-shadow:none;"/>
        </div>
        <div class="error" *ngIf="signupData.websiteUrl && !isValidUrl(signupData.websiteUrl)">Please enter a valid website (e.g. www.yourcompany.com)</div>
      </label>

      <label>
        Phone Number *
        <input type="text" input-mask [(ngModel)]="signupData.phoneNumber" placeholder="Phone number"/>
        <div class="error" *ngIf="signupData.phoneNumber && !isValidPhone(signupData.phoneNumber)">Please enter a valid 10-digit phone number</div>
      </label>

      <label>
        Email *
        <input type="text" [(ngModel)]="signupData.email" placeholder="Email"/>
        <div class="error" *ngIf="signupData.email && !isValidEmail(signupData.email)">Please check email format</div>
      </label>

      <label>
        Password *
        <input class="margin-bottom-0" *ngIf="protectedView" type="password" [(ngModel)]="signupData.desiredPassword" placeholder="Password"/>
        <input class="margin-bottom-0" *ngIf="!protectedView" type="text" [(ngModel)]="signupData.desiredPassword" placeholder="Password"/>
        <div class="d-flex justify-content-end">
          <i *ngIf="!protectedView" (click)="showProtectedView()" class="material-icons manage-strategy-icon password-protected">visibility_off</i>
          <i *ngIf="protectedView" (click)="showProtectedView()" class="material-icons manage-strategy-icon password-protected">visibility</i>
        </div>
      </label>
      <div class="error" *ngIf="passwordErrors.length">
        <div *ngFor="let err of passwordErrors">{{ err }}</div>
      </div>

      <label>
        Confirm Password *
        <input type="password" [(ngModel)]="confirmPassword" placeholder="Confirm Password"/>
      </label>

      <!-- Logo upload -->
      <div class="d-flex justify-content-between align-items-start mb-3">
        <div>
          <label style="font-weight:600;color:#333333;margin:0;">Company Logo</label>
          <div style="font-size:12px;color:#667085;">Maximum 5MB file size.</div>
          <div *ngIf="displayLogo && imageUrl" class="logo-preview mt-2" [ngStyle]="logoBg"></div>
        </div>
        <label class="button small cancel-button mb-0" style="cursor:pointer;display:inline-flex;align-items:center;gap:4px">
          Upload file
          <i class="material-icons-outlined" style="font-size:18px">file_upload</i>
          <input type="file" accept="image/*" (change)="onLogoFileChange($event)" style="display:none" class="except-input"/>
        </label>
      </div>


    </div>
  </div>

  <div class="step-footer">
    <div class="d-flex p-2 mb-2 no-plan-error" *ngIf="!planExist" style="font-size:13px">No plan found. Plan is mandatory</div>
    <div class="d-flex justify-content-end">
      <button class="button small" (click)="signup()">Next</button>
    </div>
  </div>

</div>

<div class="payment-plan-sec" *ngIf="showPlanSection">
  <div class="d-flex justify-content-center mb-5">
    <div class="d-flex bold plan-switch justify-content-center">
      <div class="pointer plan-switch-option" [ngClass]="{'active': planType === 'monthly'}" (click)="selectPlanType('monthly')">Monthly billing</div>
      <div class="pointer plan-switch-option" [ngClass]="{'active': planType === 'yearly'}" (click)="selectPlanType('yearly')">Annual(Save 15%)</div>
    </div>
  </div>
  <div class="pricing-cards d-grid gap-4">
    <div class="payment-plan d-flex flex-column basic-plan">
      <div class="plan-name mb-2 d-flex">
        <div>
          <img src="../../images/signup/basic-plan-icon.svg"/>
        </div>
        <div>Basic</div>
      </div>
      <div class="d-flex mb-4">
        <div class="plan-amount">{{(planType === 'monthly') ? '$397' : '$4,049'}}</div>
        <div class="d-flex align-items-end">{{(planType === 'monthly') ? '/month' : '/Year'}}</div>
      </div>
      <div class="d-flex flex-column plan-limits bold mb-4">
        <div>Users: 1 only</div>
        <div>Tax Plans: Limited to 12 per year</div>
      </div>
      <div class="d-flex plan-start-button pointer basic-button justify-content-center align-items-center mb-4" (click)="selectPlan('basic')">
        <div>Get Started</div>
      </div>
      <div class="d-flex flex-column plan-features">
        <div class="mb-3">Features Included:</div>
        <div class="bold mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Complimentary Basic Implementation ($350 value)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">100+ CPA-selected tax strategies</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Tax Strategy Hub </div>
        </div>
        <div class="bold mt-2 mb-2 d-flex w-100">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Real-time tax savings dashboard</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">jAIne AI Tax Planning Assistant</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">1040 Uploader for suggestions</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Custom white labeled ROI Summary, PPT Presentation, and full Tax Planning Report</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Power Hour Monthly with CPE</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Weekly Tax Lab sessions </div>
        </div>
        <div class="bold mt-2 mb-2 d-flex flex-column">
          <div class="d-flex">
            <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
            <div class="text w-100">Multi-channel support</div>
          </div>
          <div class="d-flex flex-column bold">
            <ul>
              <li class="mt-2 mb-2">Chat</li>
              <li class="mt-2 mb-2">Email</li>
              <li class="mt-2 mb-2">Phone</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="payment-plan d-flex flex-column standard-plan">
      <div class="plan-name mb-2 d-flex">
        <div>
          <img src="../../images/signup/standard-plan-icon.svg"/>
        </div>
        <div>Standard</div>
        <div class="popular-card">MOST POPULAR</div>
      </div>
      <div class="d-flex mb-4">
        <div class="plan-amount">{{(planType === 'monthly') ? '$697' : '$7,109'}}</div>
        <div class="d-flex align-items-end">{{(planType === 'monthly') ? '/month' : '/Year'}}</div>
      </div>
      <div class="d-flex flex-column plan-limits bold mb-4">
        <div>Users: 2 included($35 each additional)</div>
        <div>Tax Plans: Unlimited</div>
      </div>
      <div class="d-flex plan-start-button pointer standard-button justify-content-center align-items-center mb-4" (click)="selectPlan('standard')">
        <div>Get Started</div>
      </div>
      <div class="d-flex flex-column plan-features">
        <div class="mb-3">Features Included:</div>
        <div class="bold mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Complimentary Enhanced Implementation ($750 value)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">100+ CPA-selected tax strategies</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Tax Strategy Hub </div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Real-time tax savings dashboard</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">jAIne AI Tax Planning Assistant</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Client Portal</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Custom white labeled ROI Summary, PPT Presentation, and full Tax Planning Report</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Automated 1040 upload & beta features (Multi-Upload once available)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Monthly Power Hour Webinar with CPE</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Weekly Tax Lab sessions </div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Cash flow timeline (beta)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Priority case study submission for weekly Tax Labs (after Growth Plan subscribers)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex flex-column">
          <div class="d-flex">
            <div class="tick-mark standard"><i class="icon ion-ios-checkmark-empty"></i></div>
            <div class="text w-100">Multi-channel support</div>
          </div>
          <div class="d-flex flex-column bold">
            <ul>
              <li class="mt-2 mb-2">Chat</li>
              <li class="mt-2 mb-2">Email</li>
              <li class="mt-2 mb-2">Phone</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="payment-plan d-flex flex-column growth-plan">
      <div class="plan-name mb-2 d-flex">
        <div>
          <img src="../../images/signup/growth-plan-icon.svg"/>
        </div>
        <div>Growth</div>
      </div>
      <div class="d-flex mb-4">
        <div class="plan-amount">{{(planType === 'monthly') ? '$997' : '$10,169'}}</div>
        <div class="d-flex align-items-end">{{(planType === 'monthly') ? '/month' : '/Year'}}</div>
      </div>
      <div class="d-flex flex-column plan-limits bold mb-4">
        <div>Users: 5 included($20 each additional)</div>
        <div>Tax Plans: Unlimited</div>
      </div>
      <div class="d-flex plan-start-button pointer basic-button justify-content-center align-items-center mb-4" (click)="selectPlan('growth')">
        <div>Get Started</div>
      </div>
      <div class="d-flex flex-column plan-features">
        <div class="mb-3">Features Included:</div>
        <div class="bold mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Complimentary Growth Implementation ($750 value)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">100+ CPA-selected tax strategies</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Tax Strategy Hub </div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Real-time tax savings dashboard</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">jAIne AI Tax Planning Assistant</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Client Portal</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Custom white labeled ROI Summary, PPT Presentation, and full Tax Planning Report</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Automated 1040 upload & beta features (Multi-Upload once available)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Monthly Power Hour Webinar with CPE</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Cash flow timeline (beta)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Priority case study submission for weekly Tax Labs (Growth Plan subscribers first)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex flex-column">
          <div class="d-flex">
            <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
            <div class="text w-100">TaxPlanIQ Concierge Consultant Premium support (for all users)</div>
          </div>
          <div class="d-flex flex-column bold">
            <ul>
              <li class="mt-2 mb-2">1:1 office hours with TaxPlanIQ Concierge Consultants to review tax plans and ensure best practices.</li>
              <li class="mt-2 mb-2">Live Weekly Q&A and training sessions from marketing to selling and implementing plans, workflows to tax law, and tech updates</li>
            </ul>
          </div>
        </div>
        <div class="bold mt-2 mb-2 d-flex flex-column">
          <div class="d-flex">
            <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
            <div class="text w-100">Monthly CPE credits (36 per year per user) through the following: </div>
          </div>
          <div class="d-flex flex-column bold">
            <ul>
              <li class="mt-2 mb-2">Monthly Power Hour with CPE </li>
              <li class="mt-2 mb-2">Live Weekly Training</li>
            </ul>
          </div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">First access to beta features (free while in beta, then discounted)</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">Special Growth Program-only events</div>
        </div>
        <div class="bold mt-2 mb-2 d-flex">
          <div class="tick-mark basic"><i class="icon ion-ios-checkmark-empty"></i></div>
          <div class="text w-100">TaxPlanIQ Growth Program 100% ROI Guarantee</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['showTerms']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['showTerms']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 75%;" [ngClass]="{'tpiq-reveal': reveal['showTerms']}">
    <div style="padding: 15px; color: #333333;">
      <span class="float-right pointer" (click)="hideReveal('showTerms')">X</span>
    </div>
    <div class="body" style="padding: 15px;">
      <app-signup-terms (onTermsAccept)="acceptTerms()"></app-signup-terms>
    </div>
  </div>
</div>
